import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../Common/avatar';
import { cn } from '../../lib/utils';

interface Contact {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

interface ContactsListProps {
  title: string;
  contacts: Contact[];
  className?: string;
}

export const ContactsList: React.FC<ContactsListProps> = ({
  title,
  contacts,
  className
}) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className={cn("bg-card border border-border rounded-xl", className)}>
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      </div>
      <div className="p-4 space-y-3">
        {contacts.map((contact) => (
          <div key={contact.id} className="flex items-center gap-3 hover:bg-muted/30 rounded-lg p-2 transition-colors cursor-pointer">
            <Avatar className="h-8 w-8">
              <AvatarImage src={contact.avatar} alt={contact.name} />
              <AvatarFallback className="text-xs">
                {getInitials(contact.name)}
              </AvatarFallback>
            </Avatar>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{contact.name}</p>
              <p className="text-xs text-muted-foreground truncate">{contact.email}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
